import e from "react";
import { VisuallyHidden as t } from "../../../VisuallyHidden/VisuallyHidden.js";
import { HeartFilled as l, Heart as n } from "@olxbr/ds-icons";
const c = _ref => {
  let {
    children: o,
    isFavorited: r,
    onFavoriteClick: a
  } = _ref;
  return o ? e.createElement("button", {
    className: "olx-ad-card__badges-favorite-button",
    onClick: a,
    "data-ds-component": "DS-AdCard-Button"
  }, r ? e.createElement(e.Fragment, null, e.createElement(l, {
    className: "olx-ad-card__icon-heart-filled",
    color: "var(--color-feedback-error-100)"
  }), e.createElement(t, null, "Remover dos favoritos")) : e.createElement(e.Fragment, null, e.createElement(n, {
    color: "var(--color-neutral-120)"
  }), e.createElement(t, null, "Adicionar aos favoritos"))) : null;
};
export { c as FavoriteButton };